
const config = {
  apiOrigin: 'https://staging-api2.fedfis.com',

  env_name: 'staging',

  keycloak_client_id: 'fedfis_app',
  keycloak_logout_redirect_url: 'https://staging-www-fedfis.wasya.co',
  keycloak_realm: 'fedfis_frontend3',
  keycloak_url: 'https://login.fedfis.com',

  skip_keycloak: false,


}

export default config

